export default __webpack_public_path__ + "static/media/AssessmentLandingPage.2df9714d.png";